import React, { useState, useCallback } from "react";
import moment from "moment";
import { Grid, Divider, Button, makeStyles } from "@material-ui/core";
import { useConfigs } from "../config-provider";
import Month from "./Month";
import CalendarHeader from "./CalendarHeader";
import TimeRange from "./TimeRange";
var useStyles = makeStyles(function (theme) {
  return {
    calendar: {
      padding: theme.spacing(0, 1, 1.5)
    },
    footer: {
      padding: theme.spacing(2)
    }
  };
});

var Calendar = function Calendar(_a) {
  var value = _a.value,
      timeDisable = _a.timeDisable,
      rangeValid = _a.rangeValid,
      onChange = _a.onChange,
      onClose = _a.onClose,
      hasTime = _a.hasTime;
  var locale = useConfigs().locale;
  var classes = useStyles();

  var _b = useState(value ? value[1] === null ? value[0] || moment() : value[1] : moment()),
      currentMonth = _b[0],
      setCurrentMonth = _b[1];

  var _c = useState(value ? value[0] : null),
      startDate = _c[0],
      setStartDate = _c[1];

  var _d = useState(value ? value[1] : null),
      endDate = _d[0],
      setEndDate = _d[1];

  var _e = useState([hasTime && value ? value[0] : null, hasTime && value ? value[1] : null]),
      timeRange = _e[0],
      setTimeRange = _e[1];

  var handleChangeMonth = useCallback(function (newMonth) {
    setCurrentMonth(newMonth);
  }, []);

  function handleClickDay(day) {
    if (!startDate && !endDate) {
      setStartDate(day);
    } else if (startDate && !endDate) {
      if (startDate.isAfter(day)) {
        setStartDate(day);
      } else {
        setEndDate(day);
      }
    } else {
      if ((startDate === null || startDate === void 0 ? void 0 : startDate.isAfter(day)) || (endDate === null || endDate === void 0 ? void 0 : endDate.isBefore(day))) {
        setStartDate(day);
        setEndDate(null);
      } else {
        setStartDate(day);
      }
    }
  }

  var onTimeChange = function onTimeChange(prop) {
    return function (value) {
      if (prop === "startDateTime") {
        setTimeRange([value, timeRange[1]]);
      } else if (prop === "endDateTime") {
        setTimeRange([timeRange[0], value]);
      }
    };
  };

  function handleTimeClear() {
    setTimeRange([null, null]);
  }

  function handleClear() {
    setStartDate(null);
    setEndDate(null);
    setTimeRange([null, null]);
  }

  function handleConfirm() {
    var hasTime = !!(timeRange[0] || timeRange[1]);
    var start = null;
    var end = null;

    if (startDate && endDate) {
      start = startDate.clone();
      end = endDate.clone();
    } else if (startDate && !endDate) {
      start = startDate.clone();
      end = startDate.clone();
    } else {
      start = moment();
      end = moment();
    }

    if (start && end) {
      if (timeRange[0] === null) {
        start = start.startOf("day");
      } else {
        start.hours(timeRange[0].hours());
        start.minutes(timeRange[0].minutes());
        start.seconds(0);
      }

      if (timeRange[1] === null) {
        end = end.endOf("day");
      } else {
        end.hours(timeRange[1].hours());
        end.minutes(timeRange[1].minutes());
        end.seconds(59);
      }
    }

    onChange && onChange([start, end], hasTime);
  }

  return React.createElement(Grid, null, React.createElement(CalendarHeader, {
    month: currentMonth,
    startDate: startDate,
    endDate: endDate,
    onChange: handleChangeMonth
  }), React.createElement(Grid, {
    container: true,
    className: classes.calendar
  }, Array(2).fill(null).map(function (_, idx) {
    var month = currentMonth.clone().subtract(1 - idx, "months");
    return React.createElement(Grid, {
      key: idx,
      item: true
    }, React.createElement(Month, {
      month: month,
      rangeValid: rangeValid,
      startDate: startDate,
      endDate: endDate,
      handleClickDay: handleClickDay
    }));
  })), !timeDisable && React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(TimeRange, {
    isOneDay: !startDate || !endDate || startDate.format("YYYYMMDD") === endDate.format("YYYYMMDD"),
    timeRange: timeRange,
    onChange: onTimeChange,
    onClear: handleTimeClear
  })), React.createElement(Divider, null), React.createElement(Grid, {
    container: true,
    justify: "space-between",
    className: classes.footer
  }, React.createElement(Grid, null, React.createElement(Button, {
    color: "primary",
    onClick: handleClear
  }, locale.DateRange.clear)), React.createElement(Grid, null, React.createElement(Button, {
    color: "primary",
    style: {
      marginRight: 8
    },
    onClick: onClose
  }, locale.DateRange.cancel), React.createElement(Button, {
    color: "primary",
    variant: "contained",
    onClick: handleConfirm
  }, locale.DateRange.apply))));
};

export default Calendar;